// src/context/MediaOverlayContext.js
import React, { createContext, useState, useCallback } from 'react';

const MediaOverlayContext = createContext();

const MediaOverlayProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState(null); // 'camera' | 'gallery'
  const [photos, setPhotos] = useState([]);
  const [lastPhoto, setLastPhoto] = useState(null);
  const [shotMode, setShotMode] = useState('multi');
  const [availableDogs, setAvailableDogs] = useState([]);
  const [galleryLayout, setGalleryLayout] = useState('page');
  const [preTaggedDogIds, setPreTaggedDogIds] = useState([]);


  const [activePhotoIndex, setActivePhotoIndex] = useState(null);

// console.log('preTaggedDogIds===>',preTaggedDogIds);
// console.log('availableDogs===>', availableDogs);


// console.log('photos===>', photos);





  const openCamera = useCallback(() => {
    setMode('camera');
    setIsOpen(true);
  }, []);

  const openGallery = useCallback(() => {
    setMode('gallery');
    setIsOpen(true);
  }, []);

  const closeOverlay = useCallback(() => {
    setIsOpen(false);
    setMode(null);
  }, []);

  const toggleShotMode = () => {
    setShotMode(prev => (prev === 'multi' ? 'single' : 'multi'));
  };


const openPhotoEditor = useCallback((index) => {
  setActivePhotoIndex(index);
  setMode('photoEditor');
  setIsOpen(true);
}, []);

const closePhotoEditor = useCallback(() => {
  setActivePhotoIndex(null);
  setIsOpen(false);
  setMode(null);
}, []);


  const addPhoto = (src, options = {}) => {
    const photo = {
      src,
      tags: options.tags || [],
      checklist: {
        playing: false,
        relaxing: false,
        noFence: false,
        doorClosed: false,
        noCollars: false,
        noPoop: false,
        limitDogs: false,
        instaWorthy: false,
        instaCaption: '',
        roverCaption: ''
      }
    };
    setPhotos(prev => [...prev, photo]);
    setLastPhoto(src);
  };

  const updatePhotoAtIndex = (index, updates) => {
    setPhotos(prev => {
      const newPhotos = [...prev];
      newPhotos[index] = { ...newPhotos[index], ...updates };
      return newPhotos;
    });
  };

  return (
    <MediaOverlayContext.Provider value={{
      isOpen,
      mode,
      photos,
      lastPhoto,
      shotMode,
      openCamera,
      openGallery,
      closeOverlay,
      toggleShotMode,
      addPhoto,
      updatePhotoAtIndex,
      availableDogs,
      setAvailableDogs,
      galleryLayout,
      setGalleryLayout,
      preTaggedDogIds,
      setPreTaggedDogIds,
      activePhotoIndex,
      setActivePhotoIndex,
      openPhotoEditor,
      closePhotoEditor,
    }}>
      {children}
    </MediaOverlayContext.Provider>
  );
};

export { MediaOverlayContext, MediaOverlayProvider };
